
import { defineComponent, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { Modal } from "bootstrap";
import RespondedChargebackDrawer from "@/layout/extras/RespondedChargebackDrawer.vue";
import { DrawerComponent } from "@/assets/ts/components/_DrawerComponent";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import ApiService from "@/core/services/ApiService";
import PdfViewModal from "@/components/modals/general/PdfViewModal.vue";

export default defineComponent({
  name: "responded-chargebacks",
  components: {
    Datatable,
    PdfViewModal,
    RespondedChargebackDrawer,
  },
  setup() {
    const store = useStore();
    const searchParam = ref({
      search: "",
      id: "",
      case_number: "",
      case_status: "",
      is_reversed: "",
      mid_number: "",
      dispute_date: "",
      dispute_amount: "",
      first_name: "",
      last_name: "",
    });

    onMounted(async () => {
      loading.value = true;
      setTimeout(async () => {
        tableData.value = await getRespondedChargebacks(
          pagination.value,
          sort.value
        );

        DrawerComponent.reinitialization();

        loading.value = false;
      }, 1000);
    });

    const search = async () => {
      loading.value = true;
      tableData.value = await getRespondedChargebacks(
        pagination.value,
        sort.value
      );
      loading.value = false;
    };

    const getRespondedChargebacks = async (pagination, sort) => {
      try {
        const { page, rowsPerPage } = pagination;
        const offset = (page - 1) * rowsPerPage;

        let sortParam = "";
        const { columnName, order } = sort;
        if (columnName !== "") {
          sortParam = `&sort=${columnName},${order}`;
        }
        let url = `chargebacks/responded?group_id=${store.getters.currentUser.data.companygroupid}&offset=${offset}&limit=${rowsPerPage}${sortParam}&is_archived=0`;

        if (searchParam.value.search !== "") {
          url = `${url}&search[]=${searchParam.value.search}`;
        }
        if (searchParam.value.id !== "") {
          url = `${url}&id=${searchParam.value.id}`;
        }
        if (searchParam.value.case_number !== "") {
          url = `${url}&case_number=${searchParam.value.case_number}`;
        }
        if (searchParam.value.mid_number !== "") {
          url = `${url}&mid_number=${searchParam.value.mid_number}`;
        }
        if (searchParam.value.dispute_date !== "") {
          url = `${url}&dispute_date=${searchParam.value.dispute_date}`;
        }
        if (searchParam.value.case_status !== "") {
          url = `${url}&dispute_date=${searchParam.value.case_status}`;
        }
        if (searchParam.value.is_reversed !== "") {
          url = `${url}&dispute_date=${searchParam.value.is_reversed}`;
        }
        if (searchParam.value.dispute_amount !== "") {
          url = `${url}&mid_number=${searchParam.value.dispute_amount}`;
        }
        if (searchParam.value.first_name !== "") {
          url = `${url}&first_name=${searchParam.value.first_name}`;
        }
        if (searchParam.value.last_name !== "") {
          url = `${url}&last_name=${searchParam.value.last_name}`;
        }
        const { data } = await ApiService.get(url);
        data.data = data.data.map((responded) => {
          try {
            responded.card_holder = JSON.parse(responded.card_holder);
            responded.card = JSON.parse(responded.card_holder);
          } catch (e) {
            responded.card_holder = {
              full_name: "",
            };
            responded.card = {
              brand: "",
            };
          }

          return responded;
        });
        return data;
      } catch (err) {
        return {
          data: [],
          meta: {
            total: 0,
          },
        };
      }
    };
    const pagination = ref({
      page: 1,
      rowsPerPage: 10,
    });
    const sort = ref({
      columnName: "",
      order: "",
    });
    const checkedResponded = ref({
      parent_id: "0",
    });
    const tableHeader = ref([
      {
        key: "checkbox",
        sortable: false,
      },
      {
        name: "ID",
        key: "id",
        sortable: true,
      },
      {
        name: "Merchant Id",
        key: "merchant_id",
        sortable: true,
      },
      {
        name: "Case",
        key: "case_number",
        sortable: true,
      },
      {
        name: "Dispute Date",
        key: "dispute_date",
        sortable: true,
      },
      {
        name: "Sent Date",
        key: "sent_date",
      },
      {
        name: "Status",
        key: "case_status",
      },
      {
        name: "Results",
        key: "is_reversed",
      },
      {
        name: "Response Url",
        key: "dispute_url",
      },
      {
        name: "Actions",
        key: "actions",
      },
    ]);
    const tableData = ref({
      data: [],
      meta: {
        total: 0,
      },
    });
    const loading = ref(true);
    const onCurrentChange = async (val) => {
      pagination.value.page = val;

      loading.value = true;
      tableData.value = await getRespondedChargebacks(
        pagination.value,
        sort.value
      );
      loading.value = false;
    };

    const onSort = async (val) => {
      sort.value = val;

      loading.value = true;
      tableData.value = await getRespondedChargebacks(
        pagination.value,
        sort.value
      );
      loading.value = false;
    };

    const onItemsPerPageChange = async (val) => {
      pagination.value.rowsPerPage = val;

      loading.value = true;
      tableData.value = await getRespondedChargebacks(
        pagination.value,
        sort.value
      );
      loading.value = false;
    };

    const archiveResponded = async (id) => {
      loading.value = true;
      await ApiService.put(`chargebacks/responded/${id}?is_archived=1`, {});
      tableData.value = await getRespondedChargebacks(
        pagination.value,
        sort.value
      );
      loading.value = false;
    };

    const pdfUrl = ref("");
    const onOpenPdfView = (url) => {
      pdfUrl.value = url;
      const modal = new Modal(document.getElementById("modal_pdf_view"));
      modal.show();
    };

    const incomings = ref([]);
    const openDrawer = async (val) => {
      checkedResponded.value = val;
      const res = await ApiService.get(
        `chargebacks/incoming/${checkedResponded.value.parent_id}`
      );
      incomings.value = res.data.data.map((ele) => {
        ele.transaction = JSON.parse(ele.transaction);
        ele.card = JSON.parse(ele.card);
        ele.card_holder = JSON.parse(ele.card_holder);
        return ele;
      });
      DrawerComponent?.getInstance("responded_chargeback")?.show();
    };
    const didClosedDrawer = async () => {
      loading.value = true;
      tableData.value = await getRespondedChargebacks(
        pagination.value,
        sort.value
      );
      loading.value = false;
    };
    return {
      didClosedDrawer,
      openDrawer,
      searchParam,
      tableData,
      tableHeader,
      loading,
      checkedResponded,
      pagination,
      search,
      onCurrentChange,
      onSort,
      onItemsPerPageChange,
      archiveResponded,
      onOpenPdfView,
      pdfUrl,
      incomings,
    };
  },
});
